<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }} Inventory</h5>
  <button mat-icon-button aria-label="Close dialog" matTooltip="Close this dialog." mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <form #f="ngForm" (ngSubmit)="onSubmit(f)">

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Quantity ({{ hazardous_substance.hazardous_substance_unit_type || 'Unit Not Set' }})</mat-label>
          <input matInput
            placeholder="Quantity ({{ hazardous_substance.hazardous_substance_unit_type || 'Unit Not Set' }})"
            [(ngModel)]="hazardous_substance_link.quantity" name="quantity" type="number" #quantity />
          <mat-hint>
            Please enter the quantity that is currently held onsite. Long decimal values are rounded e.g. "5.6".
          </mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Max Quantity Allowed ({{ hazardous_substance.hazardous_substance_unit_type || 'Unit Not Set'
            }})</mat-label>
          <input matInput
            placeholder="Max Quantity Allowed ({{ hazardous_substance.hazardous_substance_unit_type || 'Unit Not Set' }})"
            [(ngModel)]="hazardous_substance_link.max_quantity_allowed" name="max_quantity_allowed" type="number"
            #max_quantity_allowed />
          <mat-hint>
            Please enter the max quantity that may be held onsite. Long decimal values are rounded e.g. "7.5".
          </mat-hint>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Location of Safety Data Sheet (SDS)</mat-label>
      <input matInput placeholder="Location of Safety Data Sheet (SDS)"
        [(ngModel)]="hazardous_substance_link.sds_location" name="sds_location" type="text" #sds_location />
      <mat-hint>
        Please enter the location of the Safety Data Sheet (SDS).
      </mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Location</mat-label>
      <input matInput
        placeholder="Location of {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}"
        [(ngModel)]="hazardous_substance_link.location" name="location" type="text" #location />
      <mat-hint>
        Please enter the location on site where the {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous
        Substance') }} is located or stored.
      </mat-hint>
    </mat-form-field>

  </form>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button (click)="onSubmit(f)" mat-raised-button [disabled]="!f.valid || inProgress" color="primary"
    class="my-2 ml-1 mr-2">
    <mat-icon>save</mat-icon>
    Update
  </button>
</mat-dialog-actions>